import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../components/info/DisplayError';
import { getSectionDetail } from '../api';
import { PerformanceAnalysisDetailResponseType } from '../types';

export const ITEMS_PER_PAGE_DEFAULT = 10;

export type PerformanceAnalysisDetailQuery = undefined;

const { FetchProvider, FetchConsumer } = createFetchContext<
  PerformanceAnalysisDetailQuery,
  PerformanceAnalysisDetailResponseType,
  AxiosResultDefaultError
>();

export function PerformanceAnalysisDetailConsumer({
  children,
}: {
  children: (args: {
    data?: PerformanceAnalysisDetailResponseType;
    loading: boolean;
  }) => ReactElement;
}) {
  return (
    <FetchConsumer>
      {({ data, error, loading, refresh }) => {
        if (error) {
          return (
            <DisplayError
              insideCard
              textBody={error.code}
              retryAction={refresh}
              loadingAction={loading}
            />
          );
        }

        return children({ data, loading });
      }}
    </FetchConsumer>
  );
}

export function PerformanceAnalysisDetailLoader({
  sectionId,
  children,
}: {
  sectionId: number;
  children: ReactElement;
}) {
  const request = useCallback(
    async (query: PerformanceAnalysisDetailQuery) => {
      return getSectionDetail(sectionId);
    },
    [sectionId],
  );

  return (
    <FetchProvider
      request={request}
      defaultQuery={undefined}
      fetchImmediately={true}
    >
      {children}
    </FetchProvider>
  );
}
